<script setup lang="ts">
import { ref, watch, onMounted } from "vue";
import { Permission } from "../../../../../types/auth";
import { FilterField, TableField } from "../../../../../components/table/table";
import ListTemplate from "../../../../../components/ui/common/ListTemplate.vue";

const props = defineProps<{
  data?: any | [];
  unit_of_measures?: any | [];
  permissions?: Permission[];
  item?: any | null;
}>();

const endPoint = "/clients/inventory/item-management/items/price-";
const title = "Variant Inventory";
const selectedData = ref<any | null>(null);
const showForm = ref(false);
const formMode = ref<
  "create" | "edit" | "view" | "showQuickView" | "toggleStatus"
>("view");
const refreshData = ref(false);

const rows = ref<any[]>(props.data);

const fields: TableField[] = [];

const filterFields: FilterField[] = [
  {
    name: "active",
    label: "Status",
    type: "select",
    value: "",
    options: [
      { id: "1", name: "Active" },
      { id: "0", name: "Inactive" },
    ],
  },
];

const changeMode = (
  mode: "create" | "edit" | "view" | "showQuickView" | "toggleStatus"
) => {
  formMode.value = mode;
  showForm.value = mode === "view" || mode === "edit" || mode === "create";
};

const handleData = (data: any) => {
  selectedData.value = data;
};

const prepareGrid = () => {
  if (props.data && props.data.length > 0) {
    const columnNames = Object.keys(props.data[0]).filter(key => key !== "id");
    fields.push({
          name: 'photo',
          caption: 'Photo',
          sortable: false,
          fieldType: "image",
        });
    columnNames.forEach((col) => {
      if (col.endsWith('_id') || col == "uid" || col == "variant") {
        return;
      }
      if (col != "code" && col != "name" && col != "photo") {
        fields.push({
          name: col,
          caption: col,
          sortable: false,
          fieldType: "number",
        });
      } else if (col != "photo") {
        fields.push({
          name: col,
          caption: col,
          sortable: false,
          fieldType: "text",
        });
      }
    });
    rows.value = props.data;
  }
}
onMounted(() => {
  prepareGrid();
});

watch(
  () => props.data,
  () => {
    prepareGrid();
  },
  { immediate: true }
);
</script>

<template>
  <ListTemplate
    :endPoint="endPoint"
    :title="title"
    :fields="fields"
    :actions="[]"
    :filterFields="filterFields"
    :tabList="[]"
    :refreshData="refreshData"
    @mode="changeMode"
    @show="showForm = true"
    :showForm="showForm"
    @data="handleData"
    :data="rows"
    :remote="false"
    :showHeader="false"
    :showQuickTour="false"
    :showQuickView="false"
    :showPagination="false"
    :allowDisable="false"
    :allow-edit="false"
    :ignore-max-height="true"
  >
    <template #header-actions> </template>
  </ListTemplate>
</template>
